/* Discover, with nothing listed.
 *
 * EMPTY, NOT WRONG (ruled 2026-09-17). There is no shop directory: no endpoint
 * lists businesses to a customer, and no shop has chosen to appear anywhere. The
 * artboard draws a search box, eight category tiles with counts and a featured
 * strip; all three of those describe a directory, and drawing them over nothing
 * would be a picture of data that does not exist.
 *
 * So the tab is its own empty state, which is the true thing to say today, plus
 * the one thing a customer can still do: collect anywhere that uses Damga.
 */
import { t } from "@damga/kit";

export function Discover({ onShowCode }: { onShowCode: () => void }) {
  return (
    <div className="empty">
      <p className="empty-title">{t("discover.empty.title")}</p>
      <p className="empty-body">{t("discover.empty.body")}</p>
      <p className="empty-body">{t("discover.empty.code")}</p>
      <button type="button" className="btn btn-primary" onClick={onShowCode}>
        {t("wallet.showCode")}
      </button>
    </div>
  );
}
